import api from "../utils/api"; // Your configured Axios instance

export const getIndustry = async () => {
  try {
    const response = await api.get("/api/industry/get");
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to get details");
  }
};
